module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.grabr) ? _c('div', {
    staticClass: "newOrder"
  }, [_c('breadcrumb', {
    attrs: {
      "nameSection": _vm.nameSection,
      "listRoutes": _vm.listRoutes
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "step_container"
  }, [_c('ul', {
    staticClass: "progressbar progress-new"
  }, [_c('li', {
    class: {
      inprocess: _vm.state1 === 1, active: _vm.state2 === 1 || _vm.state2 === 2
    },
    attrs: {
      "id": "li1",
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.changeFormView(1)
      }
    }
  }, [_c('p', [_vm._v("Datos del cliente")])]), _vm._v(" "), _c('li', {
    class: {
      inprocess: _vm.state2 === 1, active: _vm.state3 === 1 || _vm.state3 === 2, disabled: _vm.state1 === 1
    },
    attrs: {
      "id": "li2"
    },
    on: {
      "click": function($event) {
        return _vm.changeFormView(2)
      }
    }
  }, [_c('p', [_vm._v("Datos del artículo")])]), _vm._v(" "), _c('li', {
    class: {
      inprocess: _vm.state3 === 1, active: _vm.state4 === 1, disabled: _vm.state2 === 1 || _vm.state1 === 1
    },
    attrs: {
      "id": "li3"
    },
    on: {
      "click": function($event) {
        return _vm.changeFormView(3)
      }
    }
  }, [_c('p', [_vm._v("Datos de compra")])]), _vm._v(" "), _c('li', {
    class: {
      inprocess: _vm.state4 === 1, disabled: _vm.state1 === 1 || _vm.state2 === 1 || _vm.state3 === 1
    },
    attrs: {
      "id": "li4"
    },
    on: {
      "click": function($event) {
        return _vm.changeFormView(4)
      }
    }
  }, [_c('p', [_vm._v("Resumen")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-info"
  }, [(_vm.state1 === 1) ? _c('div', {}, [(_vm.grabr.id == 1) ? _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nombres y apellidos")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newName),
      expression: "newName"
    }],
    staticClass: "form-control",
    class: {
      'input': true, 'is-danger': _vm.errors.has('fullname')
    },
    attrs: {
      "type": "text",
      "name": "fullname",
      "aria-describedby": "email",
      "maxlength": 100
    },
    domProps: {
      "value": (_vm.newName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('fullname')),
      expression: "errors.has('fullname')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('fullname')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Tipo de documento")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.typeId),
      expression: "typeId"
    }],
    staticClass: "form-control form-control-lg",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.typeId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.cleanDocumentNumbers]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Selecciona")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("DNI")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Id cliente")])])])]), _vm._v(" "), (_vm.typeId == 1) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Número de documento")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.numberId),
      expression: "numberId"
    }, {
      name: "digitsonly",
      rawName: "v-digitsonly"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "document_number",
      "minlength": 8,
      "maxlength": 8
    },
    domProps: {
      "value": (_vm.numberId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.numberId = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('document_number')),
      expression: "errors.has('document_number')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('document_number')))])])]) : _vm._e(), _vm._v(" "), (_vm.typeId == 2) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Id del cliente")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.idClient),
      expression: "idClient"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Id client",
      "maxlength": 20
    },
    domProps: {
      "value": (_vm.idClient)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.idClient = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Id client')),
      expression: "errors.has('Id client')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Id client')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Número de celular")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.numberPhone),
      expression: "numberPhone"
    }, {
      name: "digitsonly-cellphone",
      rawName: "v-digitsonly-cellphone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "phone_number",
      "aria-describedby": "email",
      "minlength": 9,
      "maxlength": 15
    },
    domProps: {
      "value": (_vm.numberPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.numberPhone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('phone_number')),
      expression: "errors.has('phone_number')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('phone_number')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg btn-edit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.validateFirstFormAdvanced
    }
  }, [_vm._v("Continuar")])])]) : _vm._e(), _vm._v(" "), (_vm.grabr.id == 2) ? _c('div', [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Número de documento")]), _vm._v(" "), _c('div', {
    staticClass: "form-client"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true && this.userValidated
      }),
      expression: "{required: true && this.userValidated}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.userFinding),
      expression: "userFinding"
    }, {
      name: "digitsonly",
      rawName: "v-digitsonly"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "Nombre",
      "name": "document_number_nograbr",
      "aria-describedby": "email",
      "maxlength": "8"
    },
    domProps: {
      "value": (_vm.userFinding)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userFinding = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-append",
    attrs: {
      "id": "button-addon4"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg btn-edit btn-subir",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.validateUserById(_vm.userFinding, _vm.setUserChoosed)
      }
    }
  }, [_vm._v("Validar cliente")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('document_number_nograbr')),
      expression: "errors.has('document_number_nograbr')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('document_number_nograbr')))])]), _vm._v(" "), _c('div', {
    staticClass: "validacion-cliente",
    class: {
      'validacion-cliente-no-encontrado': _vm.mesageVerifUser == 'Cliente no existe en el sistema', 'validacion-cliente-encontrado': _vm.mesageVerifUser != 'Cliente no existe en el sistema' && _vm.mesageVerifUser != ''
    }
  }, [_c('span', [_vm._v(_vm._s(this.mesageVerifUser))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg btn-edit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.validateFistFormV2
    }
  }, [_vm._v("Continuar")])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.state2 === 1) ? _c('div', {}, [(_vm.grabr.id == 1) ? _c('div', [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Imagen del artículo")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "block-image"
  }, [_c('div', {
    staticClass: "imageProduct"
  }, [_c('img', {
    attrs: {
      "src": _vm.newImageProduct
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fas fa-image"
  })]), _vm._v(" "), _c('div', {
    staticClass: "image-content"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "data_image",
      "type": "file",
      "accept": "image/x-png, image/jpeg"
    },
    on: {
      "change": _vm.uploadImage
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newImageName),
      expression: "newImageName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "text",
      "id": "product_image",
      "name": "product_image"
    },
    domProps: {
      "value": (_vm.newImageName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newImageName = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('product_image')),
      expression: "errors.has('product_image')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('product_image')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Empaque")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packaged),
      expression: "packaged"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "name": "packaged"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.packaged = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Seleccionar")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Sin especificar")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("Sí")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("No")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nro. de orden de compra")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newNumbOrder),
      expression: "newNumbOrder"
    }, {
      name: "digitsonly",
      rawName: "v-digitsonly"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "purchase_order_number",
      "aria-describedby": "email",
      "maxlength": 20
    },
    domProps: {
      "value": (_vm.newNumbOrder)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newNumbOrder = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('purchase_order_number')),
      expression: "errors.has('purchase_order_number')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('purchase_order_number')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nombre del producto")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newInfoProduct),
      expression: "newInfoProduct"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "product_information",
      "aria-describedby": "email",
      "maxlength": 200
    },
    domProps: {
      "value": (_vm.newInfoProduct)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newInfoProduct = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('product_information')),
      expression: "errors.has('product_information')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('product_information')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" Descripción del producto (Opcional)")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newDescriptionProduct),
      expression: "newDescriptionProduct"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "product_description_optional",
      "aria-describedby": "email",
      "maxlength": 500
    },
    domProps: {
      "value": (_vm.newDescriptionProduct)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newDescriptionProduct = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Número de ejemplares")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newStockProduct),
      expression: "newStockProduct"
    }, {
      name: "digitsonly",
      rawName: "v-digitsonly"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "number_of_items_1",
      "aria-describedby": "email",
      "maxlength": 5
    },
    domProps: {
      "value": (_vm.newStockProduct)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newStockProduct = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('number_of_items_1')),
      expression: "errors.has('number_of_items_1')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('number_of_items_1')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nro. de chat en Grabr")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newLinkChat),
      expression: "newLinkChat"
    }, {
      name: "digitsonly",
      rawName: "v-digitsonly"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "purchase_chat_link",
      "aria-describedby": "email"
    },
    domProps: {
      "value": (_vm.newLinkChat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newLinkChat = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('purchase_chat_link')),
      expression: "errors.has('purchase_chat_link')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('purchase_chat_link')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Fecha de asignación al viajero")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newDateOffer),
      expression: "newDateOffer"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "purchase_order_date",
      "aria-describedby": "email",
      "max": "2100-12-31"
    },
    domProps: {
      "value": (_vm.newDateOffer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newDateOffer = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('purchase_order_date')),
      expression: "errors.has('purchase_order_date')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('purchase_order_date')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg btn-edit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.validateSecondFormAdvanced
    }
  }, [_vm._v("Continuar")])])]) : _vm._e(), _vm._v(" "), (_vm.grabr.id == 2) ? _c('div', [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Imagen del artículo")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "block-image"
  }, [_c('div', {
    staticClass: "imageProduct"
  }, [_c('img', {
    attrs: {
      "src": _vm.newImageProductV2
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fas fa-image"
  })]), _vm._v(" "), _c('div', {
    staticClass: "image-content"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "data_image",
      "type": "file",
      "accept": "image/x-png, image/jpeg"
    },
    on: {
      "change": _vm.uploadImage
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newImageName),
      expression: "newImageName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.grabr.id == 2
      }),
      expression: "{required: grabr.id  == 2}"
    }],
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "text",
      "id": "product_image",
      "name": "product_image"
    },
    domProps: {
      "value": (_vm.newImageName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newImageName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('product_image')),
      expression: "errors.has('product_image')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('product_image')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Empaque")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packaged),
      expression: "packaged"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "name": "packaged"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.packaged = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Seleccionar")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Sin especificar")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("Sí")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("No")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nombre del producto")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.grabr.id == 2
      }),
      expression: "{required: grabr.id  == 2}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newInfoProductV2),
      expression: "newInfoProductV2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "product_information_2",
      "aria-describedby": "email",
      "maxlength": 200
    },
    domProps: {
      "value": (_vm.newInfoProductV2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newInfoProductV2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('product_information_2')),
      expression: "errors.has('product_information_2')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('product_information_2')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Descripción del producto (Opcional)")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newDescriptionProductV2),
      expression: "newDescriptionProductV2"
    }],
    staticClass: "form-control",
    attrs: {
      "aria-describedby": "email",
      "maxlength": 500
    },
    domProps: {
      "value": (_vm.newDescriptionProductV2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newDescriptionProductV2 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Número de ejemplares")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.grabr.id == 2
      }),
      expression: "{required: grabr.id  == 2}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newStockProductV2),
      expression: "newStockProductV2"
    }, {
      name: "digitsonly",
      rawName: "v-digitsonly"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "number_of_items_2",
      "aria-describedby": "email"
    },
    domProps: {
      "value": (_vm.newStockProductV2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newStockProductV2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('number_of_items_2')),
      expression: "errors.has('number_of_items_2')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('number_of_items_2')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Peso de la orden")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.grabr.id == 2
      }),
      expression: "{required: grabr.id  == 2}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newWeight),
      expression: "newWeight"
    }, {
      name: "floatonly",
      rawName: "v-floatonly"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "order_weight_2",
      "aria-describedby": "email"
    },
    domProps: {
      "value": (_vm.newWeight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newWeight = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('order_weight_2')),
      expression: "errors.has('order_weight_2')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('order_weight_2')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Unidades de peso")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.grabr.id == 2
      }),
      expression: "{required: grabr.id  == 2}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.unitWeight),
      expression: "unitWeight"
    }],
    staticClass: "form-control form-control-lg",
    attrs: {
      "name": "weight_units_2"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.unitWeight = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Seleccionar")]), _vm._v(" "), _vm._l((_vm.listUnits), function(units) {
    return _c('option', {
      key: units.id,
      domProps: {
        "value": units
      }
    }, [_vm._v(_vm._s(units.attributes.name))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('weight_units_2')),
      expression: "errors.has('weight_units_2')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('weight_units_2')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg btn-edit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.validateSecondFormAdvanced
    }
  }, [_vm._v("Continuar")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.state3 === 1) ? _c('div', {}, [(_vm.grabr.id == 1) ? _c('div', [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Precio (USD)")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newCost),
      expression: "newCost"
    }, {
      name: "floatonly",
      rawName: "v-floatonly"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "price",
      "aria-describedby": "email",
      "maxlength": 7
    },
    domProps: {
      "value": (_vm.newCost)
    },
    on: {
      "keyup": function($event) {
        return _vm.setNewTax()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newCost = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('price')),
      expression: "errors.has('price')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('price')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Impuesto (USD)")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newTax),
      expression: "newTax"
    }, {
      name: "floatonly",
      rawName: "v-floatonly"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "tax",
      "aria-describedby": "email",
      "maxlength": 7
    },
    domProps: {
      "value": (_vm.newTax)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newTax = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tax')),
      expression: "errors.has('tax')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('tax')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Fee (USD)")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newCostPost),
      expression: "newCostPost"
    }, {
      name: "floatonly",
      rawName: "v-floatonly"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "fee",
      "aria-describedby": "email",
      "maxlength": 7
    },
    domProps: {
      "value": (_vm.newCostPost)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newCostPost = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('fee')),
      expression: "errors.has('fee')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('fee')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Número de viaje")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.travelNumber),
      expression: "travelNumber"
    }, {
      name: "digitsonly",
      rawName: "v-digitsonly"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "aria-describedby": "email",
      "name": "travel_number",
      "minlength": 1,
      "maxlength": 10
    },
    domProps: {
      "value": (_vm.travelNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.travelNumber = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('travel_number')),
      expression: "errors.has('travel_number')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('travel_number')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Cuenta Grabr")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.grabrAccount),
      expression: "grabrAccount"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "grabr_account",
      "aria-describedby": "email",
      "maxlength": 50
    },
    domProps: {
      "value": (_vm.grabrAccount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.grabrAccount = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('grabr_account')),
      expression: "errors.has('grabr_account')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('grabr_account')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Link de compra propuesta en Grabr (Opcional)")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: false
      }),
      expression: "{required: false}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newLinkBuying),
      expression: "newLinkBuying"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "purchase_link_optional",
      "aria-describedby": "email"
    },
    domProps: {
      "value": (_vm.newLinkBuying)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newLinkBuying = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('purchase_link_optional')),
      expression: "errors.has('purchase_link_optional')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('purchase_link_optional')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Ciudad de origen")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newCityIni),
      expression: "newCityIni"
    }],
    staticClass: "form-control form-control-lg sen-form-input-with-tooltip",
    attrs: {
      "name": "origin_city"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newCityIni = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Selecciona")]), _vm._v(" "), _vm._l((_vm.listCityOrigin), function(cityOrigin) {
    return _c('option', {
      key: cityOrigin.id,
      domProps: {
        "value": cityOrigin
      }
    }, [_vm._v(_vm._s(cityOrigin.attributes.name))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('origin_city')),
      expression: "errors.has('origin_city')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('origin_city')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Ciudad de destino")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newCityEnd),
      expression: "newCityEnd"
    }],
    staticClass: "form-control form-control-lg sen-form-input-with-tooltip",
    attrs: {
      "name": "destination_city"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newCityEnd = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Selecciona")]), _vm._v(" "), _vm._l((_vm.listCityDestiny), function(cityDestiny) {
    return _c('option', {
      key: cityDestiny.id,
      domProps: {
        "value": cityDestiny
      }
    }, [_vm._v(_vm._s(cityDestiny.attributes.name))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('destination_city')),
      expression: "errors.has('destination_city')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('destination_city')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Fecha de posible entrega")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newDatePromise),
      expression: "newDatePromise"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "possible_delivery_date",
      "aria-describedby": "email"
    },
    domProps: {
      "value": (_vm.newDatePromise)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newDatePromise = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('possible_delivery_date')),
      expression: "errors.has('possible_delivery_date')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('possible_delivery_date')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg btn-edit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.validateThirdFormAdvanced
    }
  }, [_vm._v("Continuar")])])]) : _vm._e(), _vm._v(" "), (_vm.grabr.id == 2) ? _c('div', [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Precio (USD)")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.grabr.id == 2
      }),
      expression: "{required: grabr.id  == 2}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newCostV2),
      expression: "newCostV2"
    }, {
      name: "floatonly",
      rawName: "v-floatonly"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "Nombre",
      "name": "price",
      "aria-describedby": "email",
      "maxlength": 7
    },
    domProps: {
      "value": (_vm.newCostV2)
    },
    on: {
      "keyup": function($event) {
        return _vm.setNewTax()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newCostV2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('price')),
      expression: "errors.has('price')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('price')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "width": "250px"
    }
  }, [_c('label', [_vm._v("Impuesto (USD)")]), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "12px",
      "cursor": "pointer",
      "color": "cornflowerblue",
      "text-decoration": "underline"
    },
    on: {
      "click": _vm.resetImpuesto
    }
  }, [_vm._v("(Limpiar campos)")])]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.grabr.id == 2
      }),
      expression: "{required: grabr.id  == 2}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newTaxV2),
      expression: "newTaxV2"
    }, {
      name: "floatonly",
      rawName: "v-floatonly"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "email",
      "name": "tax",
      "aria-describedby": "email"
    },
    domProps: {
      "value": (_vm.newTaxV2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newTaxV2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tax')),
      expression: "errors.has('tax')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('tax')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Costo de envío (USD)")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.grabr.id == 2
      }),
      expression: "{required: grabr.id  == 2}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newCostPostV2),
      expression: "newCostPostV2"
    }, {
      name: "floatonly",
      rawName: "v-floatonly"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "email",
      "name": "shipping_cost",
      "aria-describedby": "email"
    },
    domProps: {
      "value": (_vm.newCostPostV2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newCostPostV2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('shipping_cost')),
      expression: "errors.has('shipping_cost')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('shipping_cost')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Link de compra " + _vm._s(_vm.grabr.id == 1 ? '(Opcional)' : ''))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.grabr.id == 2,
        url: true
      }),
      expression: "{required:grabr.id == 2,url:true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newLinkBuyingV2),
      expression: "newLinkBuyingV2"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "email",
      "aria-describedby": "email",
      "name": "purchase_link",
      "maxlength": 200
    },
    domProps: {
      "value": (_vm.newLinkBuyingV2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newLinkBuyingV2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('purchase_link')),
      expression: "errors.has('purchase_link')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('purchase_link')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Ciudad de origen")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.grabr.id == 2
      }),
      expression: "{required: grabr.id  == 2}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newCityIni),
      expression: "newCityIni"
    }],
    staticClass: "form-control form-control-lg sen-form-input-with-tooltip",
    attrs: {
      "name": "origin_city"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newCityIni = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.filtrar]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Selecciona")]), _vm._v(" "), _vm._l((_vm.listCityOrigin), function(cityOrigin) {
    return _c('option', {
      key: cityOrigin.id,
      domProps: {
        "value": cityOrigin
      }
    }, [_vm._v(_vm._s(cityOrigin.attributes.name))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('origin_city')),
      expression: "errors.has('origin_city')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('origin_city')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Ciudad de destino")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.grabr.id == 2
      }),
      expression: "{required: grabr.id  == 2}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newCityEnd),
      expression: "newCityEnd"
    }],
    staticClass: "form-control form-control-lg sen-form-input-with-tooltip",
    attrs: {
      "name": "destination_city"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newCityEnd = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Selecciona")]), _vm._v(" "), _vm._l((_vm.listCityDestinyFilter), function(cityDestiny) {
    return _c('option', {
      key: cityDestiny.id,
      domProps: {
        "value": cityDestiny
      }
    }, [_vm._v(_vm._s(cityDestiny.attributes.name))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('destination_city')),
      expression: "errors.has('destination_city')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('destination_city')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg btn-edit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.validateThirdFormAdvanced
    }
  }, [_vm._v("Continuar")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.state4 === 1) ? _c('div', {}, [(_vm.grabr.id == 1) ? _c('div', [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "form-content-info-resume"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Nombres y apellidos:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.newName))])]), _vm._v(" "), (_vm.typeId == 1) ? _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Número de documento:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.numberId))])]) : _vm._e(), _vm._v(" "), (_vm.typeId == 2) ? _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("ID del cliente:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.idClient))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Número telefónico:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.numberPhone))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-info-resume"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Empaque:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.packaged == 1 ? "Sin especificar" : (_vm.packaged == 2 ? "Sí" : "No")))])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Número de orden de compra:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.newNumbOrder))])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Título de la orden de compra:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.newInfoProduct))])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Descripción del producto:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.newDescriptionProduct))])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Número de ejemplares:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.newStockProduct))])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Nro. de chat Grabr;")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_c('a', {
    attrs: {
      "href": _vm.newLinkChat
    }
  }, [_vm._v(_vm._s(_vm.newLinkChat))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Fecha de orden de compra:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm._f("spanishDate")(_vm.newDateOffer)))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-info-resume"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Precio:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.newCost))])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Impuesto (USD):")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(Number(Math.round(parseFloat(_vm.newTax) + 'e2') + 'e-2').toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Fee (USD):")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(Number(Math.round(parseFloat(_vm.newCostPost) + 'e2') + 'e-2').toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [(_vm.grabr.id == 1) ? _c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Link de compra propuesta en Grabr:")]) : _c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Link de compra:")]), _vm._v(" "), (_vm.grabr.id == 1 && _vm.newLinkBuying != null && _vm.newLinkBuying != '') ? _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_c('a', {
    attrs: {
      "href": _vm.newLinkBuying
    }
  }, [_vm._v(_vm._s(_vm.newLinkBuying))])]) : (_vm.grabr.id == 2 && _vm.newLinkBuyingV2 != null && _vm.newLinkBuyingV2 != '') ? _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_c('a', {
    attrs: {
      "href": _vm.newLinkBuyingV2
    }
  }, [_vm._v(_vm._s(_vm.newLinkBuyingV2))])]) : _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v("No definido")])]), _vm._v(" "), (_vm.travelNumber != null) ? _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Número de viaje:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.travelNumber))])]) : _vm._e(), _vm._v(" "), (_vm.grabrAccount != null) ? _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Cuenta en Grabr")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.grabrAccount))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Ciudad de origen:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.newCityIni.attributes.name))])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Ciudad de destino:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.newCityEnd.attributes.name))])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Fecha de posible entrega:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm._f("spanishDate")(_vm.newDatePromise)))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-info-resume text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-edit",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.sendCompleteForm
    }
  }, [_vm._v("Crear orden Grabr")])])]) : _vm._e(), _vm._v(" "), (_vm.grabr.id == 2) ? _c('div', [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "form-content-info-resume"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Número de documento:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.userValidated.attributes.profile.attributes.document_number))])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Nombre del cliente:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.userValidated.attributes.profile.attributes.name))])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Apellido del cliente:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.userValidated.attributes.profile.attributes.surnames))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-info-resume"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Empaque:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.packaged == 1 ? "Sin especificar" : (_vm.packaged == 2 ? "Sí" : "No")))])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Título de la orden de compra:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.newInfoProductV2))])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Descripción del producto:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.newDescriptionProductV2))])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Número de ejemplares:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.newStockProductV2))])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Peso de la orden:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(Number(Math.round(parseFloat(_vm.newWeight) + 'e2') + 'e-2').toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Unidad de medida del peso:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.unitWeight.attributes.name))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-info-resume"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Precio real:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(Number(Math.round(parseFloat(_vm.newCostV2) + 'e2') + 'e-2').toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Impuesto real:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(Number(Math.round(parseFloat(_vm.newTaxV2) + 'e2') + 'e-2').toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v("Costo de envío real:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v(_vm._s(Number(Math.round(parseFloat(_vm.newCostPostV2) + 'e2') + 'e-2').toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Link real de compra:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_c('a', {
    attrs: {
      "href": _vm.newLinkBuyingV2
    }
  }, [_vm._v(_vm._s(_vm.newLinkBuyingV2))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Ciudad de origen:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.newCityIni.attributes.name))])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-block"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Ciudad de destino:")]), _vm._v(" "), _c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v(_vm._s(_vm.newCityEnd.attributes.name))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-content-info-resume text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-edit",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.sendCompleteForm
    }
  }, [_vm._v("Crear orden Direct")])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('b-modal', {
    ref: "validacionmodal",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "id": "validacionmodal",
      "centered": ""
    },
    on: {
      "hide": function($event) {
        return _vm.toNextView()
      }
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close",
      "block": ""
    },
    on: {
      "click": _vm.hideModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-correcto text-center"
  }, [_c('div', {
    staticClass: "validacion-body"
  }, [_c('h1')])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-edit",
    attrs: {
      "type": "button",
      "block": ""
    },
    on: {
      "click": _vm.hideModal
    }
  }, [_vm._v("Continuar")])])])])], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-block-text"
  }, [_c('span', [_vm._v("Datos del cliente")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-block-text"
  }, [_c('span', [_vm._v("Datos del cliente")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-block-text"
  }, [_c('span', [_vm._v("Datos del artículo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "data_image"
    }
  }, [_c('span', {
    staticClass: "btn btn-primary"
  }, [_c('img', {
    staticClass: "logo-sendibox",
    attrs: {
      "src": "/static/img/camara.svg",
      "alt": ""
    }
  }), _vm._v("Seleccionar imagen")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-block-text"
  }, [_c('span', [_vm._v("Datos del artículo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "data_image"
    }
  }, [_c('span', {
    staticClass: "btn btn-primary"
  }, [_c('img', {
    staticClass: "logo-sendibox",
    attrs: {
      "src": "/static/img/camara.svg",
      "alt": ""
    }
  }), _vm._v("Seleccionar imagen")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-block-text"
  }, [_c('span', [_vm._v("Datos de compra")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formTitle"
  }, [_c('h1', [_vm._v("Datos de compra")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-block-text"
  }, [_c('span', [_vm._v("Resumen de la orden de compra")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-content-block form-resume-subtitle"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Datos del cliente")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-content-block form-content-block form-resume-subtitle"
  }, [_c('span', {
    staticClass: "form-content-block-item form-content-block-ellipsis"
  }, [_vm._v("Datos del artículo:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-content-block form-content-block form-resume-subtitle"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Datos de compra:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-block-text"
  }, [_c('span', [_vm._v("Resumen de la orden de compra")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-content-block form-content-block form-resume-subtitle"
  }, [_c('span', {
    staticClass: "form-content-block-item"
  }, [_vm._v("Datos del cliente")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-content-block form-content-block form-resume-subtitle"
  }, [_c('span', [_vm._v("Datos del artículo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-content-block form-resume-subtitle"
  }, [_c('span', [_vm._v("Datos de compra")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e131fd84"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Tasks.vue
// module id = 1919
// module chunks = 1